import type { RouteRecordRaw } from 'vue-router'
import { TokenManager } from '@eci-saas/utils'
import { setupLayouts } from 'virtual:generated-layouts'
// eslint-disable-next-line import/no-duplicates
import { createRouter, createWebHistory } from 'vue-router'
// eslint-disable-next-line import/no-duplicates
import { routes } from 'vue-router/auto-routes'
import { useWorkspaceStore } from '~/stores/workspace'

// 需要重定向的路由集合
const redirectRoutes = [
  {
    path: '/:workspaceId(\\d+)',
    redirect: () => {
      return `/inbox`
    },
  },
]

export const router = createRouter({
  history: createWebHistory(),
  routes: setupLayouts(routes).concat(redirectRoutes as RouteRecordRaw[]),
})

// 检查登录状态的公共函数
function checkAuth() {
  const localTokenManager = new TokenManager(true)
  const sessionTokenManager = new TokenManager(false)
  const token = localTokenManager.getToken() || sessionTokenManager.getToken()

  if (!token) {
    window.location.href = import.meta.env.VITE_APP_AUTH_URL_LCMS
    return false
  }
  return true
}

// 监听页面从 bfcache 恢复（浏览器回退时触发）
window.addEventListener('pageshow', (event) => {
  // event.persisted 为 true 表示页面是从 bfcache 恢复的（即浏览器回退）
  if (event.persisted) {
    checkAuth()
  }
})

router.beforeEach((to, _from, next) => {
  if (to.path === '/oauth-callback' || to.path === '/403' || to.name === '404') {
    next()
    return
  }

  if (!checkAuth()) {
    return
  }

  const workspaceStore = useWorkspaceStore()

  if ('workspaceId' in to.params && to.params.workspaceId) {
    const workspaceId = Number.parseInt(String(to.params.workspaceId))
    if (workspaceStore.workspaceList.length > 0 && !Number.isNaN(workspaceId)) {
      const workspace = workspaceStore.getWorkspaceById(workspaceId)
      if (workspace) {
        workspaceStore.setCurrentWorkspace(workspace)
      }
      else {
        workspaceStore.setCurrentWorkspace(workspaceStore.workspaceList[0])
      }
    }
  }

  next()
})
